const NAME = 'materialMenus';

import {MDCMenu, Corner} from '@material/menu';
import {MDCMenuSurfaceFoundation} from '@material/menu-surface/foundation';

import {MDCRipple} from '@material/ripple';

import {purgeEls} from '@netx/core/utils/purgeEls';
import {simulateClickBody} from '@netx/core-next/utils/browser';

import {arrowNavigationPatch} from './patches/mdc-list';

class Menu {
	/**
	 * @method
	 */
	constructor(anchorEl, view, opts = {}) {
		this.anchorEl = anchorEl;
		this.view = view;

		const el = (this.el = anchorEl.querySelector('.mdc-menu-surface'));
		const dropdownToggle = (this.dropdownToggle =
			el.parentElement.querySelector('.menu-button, .dropdown-toggle'));

		this.hoist =
			opts.hoist === true || el.classList.contains('mdc-menu--hoist');
		this.horizontal =
			opts.horizontal === true || el.classList.contains('mdc-menu--horizontal');
		this.destroyOnClose = opts.destroyOnClose === true;

		el.addEventListener(
			'MDCMenuSurface:closed',
			(this.onClosed = this.closed.bind(this)),
		);
		el.addEventListener(
			'MDCMenuSurface:opened',
			(this.onOpen = this.opened.bind(this)),
		);
		el.addEventListener(
			'MDCList:action',
			(this.onAction = this.itemSelected.bind(this)),
		);

		// For our "special" menus that have dropdown in them
		// we need to not do this but until the facets refactor to the sidebar
		// we need this
		$(el)
			.on('shown.bs.dropdown', () => {
				this.recalculatePosition();
			})
			.on('hidden.bs.dropdown', () => {
				this.recalculatePosition();
			});

		el.addEventListener('click', (this.onClick = this.clicked.bind(this)));
		el.addEventListener('touchstart', (this.onTap = this.clicked.bind(this)));
		if (dropdownToggle) {
			// If in an mdc-list-item the ripple gets double applied
			if (!dropdownToggle.closest('.mdc-list-item__meta')) {
				this.ripple = new MDCRipple(dropdownToggle);
				this.ripple.unbounded = true;
			}

			dropdownToggle.addEventListener(
				'click',
				(this.onToggleClick = this.toggleClicked.bind(this)),
			);
			dropdownToggle.addEventListener(
				'touchstart',
				(this.onToggleTap = this.toggleClicked.bind(this)),
			);
			dropdownToggle.addEventListener(
				'keydown',
				(this.onToggleKeydown = this.toggleKeyedDown.bind(this)),
			);
		}

		if (!this.hoist) {
			this.menu = this.createMenu(el); //new MDCMenu(el);
		}

		this._open = false;

		if (
			opts.autoOpen === true ||
			el.classList.contains('mdc-menu-surface--auto-open')
		) {
			this.open();
		}
	}

	/** @method */
	cleanUp() {
		if (this.backdrop) {
			document.body.removeChild(this.backdrop);
			delete this.backdrop;
		}

		const menu = this.menu;
		if (!menu) return;

		// Put the element back - would be nice if the mdc-menu-surface did this
		// maybe they do and i missed it (like a config or whatever)
		if (this.hoist && menu.menuSurface_.foundation_.isHoistedElement_) {
			this.anchorEl.appendChild(menu.root_.parentNode.removeChild(menu.root_));
		}

		menu.destroy();
		delete this.menu;
	}

	/**
	 * @method
	 * @param {event} e `click` event
	 */
	clicked(e) {
		// When we click on an action our event listeners in core fire
		// but mdc list items (which live in mdc menus) can be triggered
		// by `space`, `enter` and `click`
		// So, when a click occurs we do not want to fire the action off in
		// here as to not have it fire twice
		// When we rework our actions we should keep this in mind
		if (e.target.classList.contains('nx-action')) {
			this._ignoreItemSelection = true;
			setTimeout(() => {
				this._ignoreItemSelection = false;
			}, 20);
		}
	}

	/** @method */
	close() {
		const menu = this.menu;
		if (!menu || !menu.open) return;

		menu.open = false;
	}

	/** @method */
	closed() {
		if (!this._open) return;
		this._open = false;
		this.anchorEl.classList.remove('open');

		if (this.view.onMenuClose) {
			this.view.onMenuClose(this.menu);
		}

		if (this.destroyOnClose) {
			this.destroy();
		} else if (this.hoist) {
			this.cleanUp();
		}
	}

	/** @method */
	createMenu() {
		const menu = (this.menu = new MDCMenu(this.el));
		arrowNavigationPatch(menu.list_);

		// DAM-15440 - if the menu is open when the view re-renders,
		// the menu will not reopen, because this.menu.open remains falsely true
		menu.open = false;

		if (this.horizontal) {
			menu.list_.foundation_.setVerticalOrientation(false);
		}

		// Need to look into mdc's pull request
		// HACK
		// Support mobile "tap"
		menu.menuSurface_.handleBodyTap_ = (evt) => {
			return menu.menuSurface_.foundation_.handleBodyClick(evt);
		};
		menu.menuSurface_.registerBodyTapListener_ = () => {
			return document.body.addEventListener(
				'touchstart',
				menu.menuSurface_.handleBodyTap_,
			);
		};
		menu.menuSurface_.deregisterBodyTapListener_ = function () {
			return document.body.removeEventListener(
				'touchstart',
				menu.menuSurface_.handleBodyTap_,
			);
		};
		menu.menuSurface_.listen(
			MDCMenuSurfaceFoundation.strings.OPENED_EVENT,
			menu.menuSurface_.registerBodyTapListener_,
		);
		menu.menuSurface_.listen(
			MDCMenuSurfaceFoundation.strings.CLOSED_EVENT,
			menu.menuSurface_.deregisterBodyTapListener_,
		);

		// menu-surface/foundation is not checking if the menu is even open. So, it will
		// will add the `mdc-menu-surface--open` modifier class and immediately remove it
		// (as the menu animation does not need to occur), which makes the menu toggle light up
		// We use thae `mdc-menu-surface--open` to display that a menu toggle is active
		menu.menuSurface_.foundation_.close = _.wrap(
			menu.menuSurface_.foundation_.close,
			(close) => {
				if (!menu.open) return;

				// On mobile we wind up clicking on any element that is behind the menu
				// in that click position - do not allow any interactive clicks for 300ms
				this.reEnableTouchEventsTimeout &&
					clearTimeout(this.reEnableTouchEventsTimeout);
				document.body.style['pointer-events'] = 'none';

				this.reEnableTouchEventsTimeout = setTimeout(() => {
					document.body.style['pointer-events'] = '';
				}, 300);

				close.call(menu.menuSurface_.foundation_);
			},
		);

		return menu;
	}

	/** @method */
	destroy() {
		if (this.dropdownToggle) {
			this.dropdownToggle.removeEventListener('click', this.onToggleClick);
			this.dropdownToggle.removeEventListener('touchstart', this.onToggleTap);
			delete this.dropdownToggle;
		}

		this.cleanUp();
		delete this.menu;

		this.ripple && this.ripple.destroy();

		const el = this.el;
		el.removeEventListener('click', this.onClick);
		el.removeEventListener('touchstart', this.onTap);
		el.removeEventListener('MDCList:action', this.onAction);
		el.removeEventListener('MDCMenuSurface:closed', this.onClosed);
		el.removeEventListener('MDCMenuSurface:opened', this.onOpen);
		$(el).off('.bs.dropdown');

		delete this.anchorEl;
		delete this.el;
		delete this.view;
	}

	/**
	 * @method
	 * @param {event} e `MDCList:action` event
	 */
	itemSelected(e) {
		// Defer because our `click` event comes immediately after `MDCList:action`
		// we want to know if it was via a `click` or other (`space`, `enter`)
		_.defer(() => {
			if (!this._ignoreItemSelection) {
				const item = this.menu.list_.listElements[e.detail.index];
				if (!item || !item.classList.contains('nx-action')) {
					if (this.view.onMenuItemSelect) {
						this.view.onMenuItemSelect(item, this.menu);
					}
					return;
				}

				// Pass along to our action event handler
				const evt = new MouseEvent('click', {
					bubbles: false,
					cancelable: true,
					view: window,
				});
				item.dispatchEvent(evt);
			}
		});
	}

	/** @method */
	open() {
		const el = this.el;
		let menu = this.menu;

		simulateClickBody();

		if (menu && menu.open) return;

		if (this.hoist) {
			menu = this.createMenu();
			menu.setFixedPosition(true);
			menu.setAnchorCorner(Corner.BOTTOM_START);
			menu.hoistMenuToBody();

			const backdrop = (this.backdrop = document.createElement('div'));
			backdrop.classList.add('mdc-menu-backdrop');
			document.body.appendChild(backdrop);

			const cancelItem = el.querySelector('.mdc-list-item.cancel');
			cancelItem &&
				cancelItem.classList.toggle(
					'mdc-list-item--disabled',
					window.innerWidth >= 767,
				);
		}

		if (!menu || menu.open) return;

		this.reEnableTouchEventsTimeout &&
			clearTimeout(this.reEnableTouchEventsTimeout);
		menu.root_.style['pointer-events'] = 'none';

		menu.open = true;
	}

	/** @method */
	opened() {
		if (this._open) return;

		const menu = this.menu;

		this._open = true;
		this.anchorEl.classList.add('open');

		if (this.view.onMenuOpen) {
			this.view.onMenuOpen(menu);
		}

		// keyboard accessibility
		menu.items.length && menu.items[0].focus();

		this.reEnableTouchEventsTimeout &&
			clearTimeout(this.reEnableTouchEventsTimeout);
		this.reEnableTouchEventsTimeout = setTimeout(() => {
			menu.root_.style['pointer-events'] = '';
		}, 300);
	}

	/** @method */
	recalculatePosition() {
		if (!this.menu || !this._open) return;
		const menuSurface = this.menu.menuSurface_.foundation_;
		menuSurface.dimensions_ = menuSurface.adapter_.getInnerDimensions();
		menuSurface.autoPosition_();
	}

	/** @method */
	toggle() {
		const menu = this.menu;
		!menu || !menu.open ? this.open() : this.close();
	}

	/**
	 * @method
	 * @param {event} e `click` event
	 */
	toggleClicked(e) {
		e.preventDefault();
		e.stopPropagation();

		this.open();
	}
	/**
	 * @method
	 * @param {event} e `keydown` event
	 * open menus with enter/space
	 *
	 * todo: remove with react
	 */
	toggleKeyedDown(e) {
		const code = e.which;
		// space or enter
		if (code === 13 || code === 32) {
			e.preventDefault();
			e.stopPropagation();

			if (e.currentTarget.classList.contains('menu-button')) {
				$(e.currentTarget).trigger('click.data-action-context');
			} else {
				this.toggle();
			}
		}
	}
}

export default function (target) {
	if (!target || target.hasFunctionality(NAME)) return target;

	target.addInitializer((instance, opts = {}) => {
		let materialMenus = [];

		const cleanUp = () => {
			_.invoke(materialMenus, 'destroy');
			materialMenus = [];
		};

		instance.addMaterialMenu = (el, show) => {
			const menu = new Menu(el, instance);
			materialMenus.push(menu);
			show && menu.open();
		};

		// Hey, listen!
		instance
			.on('preRenderHook', cleanUp)
			.on('removeHook', cleanUp)
			.on('renderedHook', () => {
				const el = instance.el;
				const els = el.classList.contains('mdc-menu-surface--anchor')
					? [el]
					: purgeEls(
							[...instance.el.querySelectorAll('.mdc-menu-surface--anchor')],
							instance.getExcludedViews(),
					  );
				materialMenus = els.map((anchorEl) => {
					return new Menu(anchorEl, instance, opts.materialMenus);
				});
			});
	}, NAME);

	return target;
}
